export default __webpack_public_path__ + "static/mb-social-3fe573e2bcf071894d3195bf99d25d4c.jpg";